import React from 'react'
import { Tooltip } from 'antd'

interface SidebarRailItemProps {
  icon: React.ReactNode
  label: string
  active?: boolean
  onClick?: () => void
}

const SidebarRailItem: React.FC<SidebarRailItemProps> = ({ icon, label, active, onClick }) => {
  return (
    <Tooltip title={label} placement="right">
      <button
        type="button"
        className={`gt-sidebar-rail-item${active ? ' gt-sidebar-rail-item-active' : ''}`}
        onClick={onClick}
        aria-label={label}
        aria-current={active ? 'page' : undefined}
      >
        <span className="gt-sidebar-rail-item-icon">{icon}</span>
      </button>
    </Tooltip>
  )
}

export default SidebarRailItem
